import {BaseIdModel} from 'common-shared';

export class UnitConversionModel extends BaseIdModel {
  BaseUnitId: string;
  UnitId: string;
  ConversionFactor: number;
  Comment?: any;
}
